import { BigIcon, Cleanstate } from './styles'

Cleanstate.BigIcon = BigIcon

export default Cleanstate
